/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Integration_Past_4Inputs */



/**
* | output |
* | --- |
* | "talked to connected services" |
*
* @param {Chat_Summary_Integration_Past_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_integration_past_4 = /** @type {((inputs?: Chat_Summary_Integration_Past_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Integration_Past_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("mit verbundenen Diensten gesprochen")
	return /** @type {LocalizedString} */ ("talked to connected services")
});